.defaultIcon {
  color: var(--color-text-secondary);
}

.disabledDefaultIcon {
  color: var(--color-neutral-70);
}
